var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',{style:({width: '100%',display:'none'})},[_vm._v(" Footer ")])}
var staticRenderFns = []

export { render, staticRenderFns }